import axios from "axios";
import { drawId, Token } from "../urlParams";
import { REACT_APP_USER_API_URL } from "../../envVariables";


    export interface   ticketsProps{
            count:number;
            rows:gridRowsProps[]
        }

export interface gridRowsProps{
    id:string;
    gameId:string;
    drawId:string;
    gridItems:[];
    game:{
      gridSize:string
    }
}

export const getTickets = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_USER_API_URL}lottery/tickets-list?drawId=${drawId}` ,{
          headers: {
            'Authorization': `AccessToken=${Token}` 
          }
        }
      );
       
      return response.data.data.tickets as ticketsProps
    } catch (error) {
      console.error('Error fetching tickets:');
      throw error; 
    }
  };